module.exports = __webpack_public_path__ + "media/images/ubs-05c12f4416a2080c752af014bc46e98f.png";